import React from 'react';
import { Logo } from '../components/Logo';
import { ArrowLeftIcon } from 'lucide-react';
export function BrandBook() {
  const blues = [{
    name: 'blue-200',
    hex: '#BFDBFE',
    class: 'bg-blue-200'
  }, {
    name: 'blue-300',
    hex: '#93C5FD',
    class: 'bg-blue-300'
  }, {
    name: 'blue-400',
    hex: '#60A5FA',
    class: 'bg-blue-400'
  }, {
    name: 'blue-500',
    hex: '#3B82F6',
    class: 'bg-blue-500'
  }, {
    name: 'blue-600',
    hex: '#2563EB',
    class: 'bg-blue-600'
  }];
  const grays = [{
    name: 'gray-900',
    hex: '#111827',
    class: 'bg-gray-900'
  }, {
    name: 'gray-700',
    hex: '#374151',
    class: 'bg-gray-700'
  }, {
    name: 'gray-600',
    hex: '#4B5563',
    class: 'bg-gray-600'
  }, {
    name: 'gray-500',
    hex: '#6B7280',
    class: 'bg-gray-500'
  }, {
    name: 'gray-400',
    hex: '#9CA3AF',
    class: 'bg-gray-400'
  }, {
    name: 'gray-200',
    hex: '#E5E7EB',
    class: 'bg-gray-200'
  }, {
    name: 'gray-100',
    hex: '#F3F4F6',
    class: 'bg-gray-100'
  }];
  return <div className="min-h-screen bg-gray-50" data-id="element-264">
      {/* Header */}
      <header className="sticky top-0 z-10 bg-white border-b border-gray-200" data-id="element-265">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-266">
          <div className="flex items-center gap-3" data-id="element-267">
            <Logo showText={false} size="sm" data-id="element-268" />
            <span className="text-sm font-medium text-gray-900" data-id="element-269">
              Obra Digital — Brand Book
            </span>
          </div>
          <a href="#" onClick={e => {
          e.preventDefault();
          window.location.hash = '';
          window.location.reload();
        }} className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-900 transition-colors" data-id="element-270">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-271" />
            Volver al sitio
          </a>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12 space-y-16" data-id="element-272">
        {/* Logo Section */}
        <section data-id="element-273">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-274">Logo</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-275">
            Versiones del logo para diferentes contextos.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-276">
            {/* Logo on white */}
            <div className="bg-white rounded-2xl border border-gray-200 p-10 flex items-center justify-center" data-id="element-277">
              <Logo showText={true} size="lg" variant="dark" data-id="element-278" />
            </div>
            {/* Logo on dark */}
            <div className="bg-[#111827] rounded-2xl p-10 flex items-center justify-center" data-id="element-279">
              <Logo showText={true} size="lg" variant="light" data-id="element-280" />
            </div>
            {/* Isotipo on white */}
            <div className="bg-white rounded-2xl border border-gray-200 p-10 flex items-center justify-center" data-id="element-281">
              <Logo showText={false} size="lg" variant="dark" data-id="element-282" />
            </div>
            {/* Isotipo on dark */}
            <div className="bg-[#111827] rounded-2xl p-10 flex items-center justify-center" data-id="element-283">
              <Logo showText={false} size="lg" variant="light" data-id="element-284" />
            </div>
          </div>

          {/* Size variants */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-285">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-286">
              Tamaños
            </p>
            <div className="flex items-end gap-10" data-id="element-287">
              <div className="text-center" data-id="element-288">
                <Logo showText={true} size="sm" variant="dark" data-id="element-289" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-290">sm</span>
              </div>
              <div className="text-center" data-id="element-291">
                <Logo showText={true} size="md" variant="dark" data-id="element-292" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-293">md</span>
              </div>
              <div className="text-center" data-id="element-294">
                <Logo showText={true} size="lg" variant="dark" data-id="element-295" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-296">lg</span>
              </div>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-2 gap-4 text-sm text-gray-500" data-id="element-297">
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-298">
              <span className="font-medium text-gray-700" data-id="element-299">Espacio mínimo</span>
              <p className="text-xs mt-1" data-id="element-300">
                Mantener al menos 1x el ancho del isotipo como margen.
              </p>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-301">
              <span className="font-medium text-gray-700" data-id="element-302">No distorsionar</span>
              <p className="text-xs mt-1" data-id="element-303">
                Nunca estirar, rotar o cambiar los colores del logo.
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-304" />

        {/* Color Palette */}
        <section data-id="element-305">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-306">Colores</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-307">
            Paleta de colores de la marca.
          </p>

          {/* Primary */}
          <div className="mb-8" data-id="element-308">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-309">
              Primario
            </p>
            <div className="flex items-start gap-4" data-id="element-310">
              <div className="w-24 h-24 rounded-xl bg-blue-600 shadow-sm" data-id="element-311" />
              <div data-id="element-312">
                <p className="font-semibold text-gray-900" data-id="element-313">Blue 600</p>
                <p className="text-sm text-gray-500 font-mono" data-id="element-314">#2563EB</p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-315">bg-blue-600</p>
              </div>
            </div>
          </div>

          {/* Blue scale */}
          <div className="mb-8" data-id="element-316">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-317">
              Escala de azules
            </p>
            <div className="flex gap-3" data-id="element-318">
              {blues.map(color => <div key={color.name} className="text-center" data-id="element-319">
                  <div className={`w-14 h-14 rounded-lg ${color.class} shadow-sm`} data-id="element-320" />
                  <p className="text-[10px] text-gray-500 mt-2 font-mono" data-id="element-321">
                    {color.hex}
                  </p>
                  <p className="text-[10px] text-gray-400" data-id="element-322">{color.name}</p>
                </div>)}
            </div>
          </div>

          {/* Gray scale */}
          <div className="mb-8" data-id="element-323">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-324">
              Escala de grises
            </p>
            <div className="flex gap-3" data-id="element-325">
              {grays.map(color => <div key={color.name} className="text-center" data-id="element-326">
                  <div className={`w-14 h-14 rounded-lg ${color.class} shadow-sm border border-gray-200`} data-id="element-327" />
                  <p className="text-[10px] text-gray-500 mt-2 font-mono" data-id="element-328">
                    {color.hex}
                  </p>
                  <p className="text-[10px] text-gray-400" data-id="element-329">{color.name}</p>
                </div>)}
            </div>
          </div>

          {/* Dark background */}
          <div data-id="element-330">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-331">
              Fondo oscuro
            </p>
            <div className="flex items-start gap-4" data-id="element-332">
              <div className="w-24 h-24 rounded-xl bg-[#111827] shadow-sm" data-id="element-333" />
              <div data-id="element-334">
                <p className="font-semibold text-gray-900" data-id="element-335">Dark</p>
                <p className="text-sm text-gray-500 font-mono" data-id="element-336">#111827</p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-337">bg-[#111827]</p>
              </div>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-338" />

        {/* Typography */}
        <section data-id="element-339">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-340">Tipografía</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-341">
            Inter — La fuente principal de la marca.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-6" data-id="element-342">
            <div data-id="element-343">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-344">
                H1 — text-4xl font-extrabold
              </span>
              <h1 className="text-4xl font-extrabold text-gray-900" data-id="element-345">
                Nunca más pierdas registro
              </h1>
            </div>
            <div data-id="element-346">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-347">
                H2 — text-3xl font-bold
              </span>
              <h2 className="text-3xl font-bold text-gray-900" data-id="element-348">
                Precio simple y transparente
              </h2>
            </div>
            <div data-id="element-349">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-350">
                H3 — text-2xl font-bold
              </span>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-351">
                El caos de la información
              </h3>
            </div>
            <div data-id="element-352">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-353">
                H4 — text-xl font-semibold
              </span>
              <h4 className="text-xl font-semibold text-gray-900" data-id="element-354">
                Así de simple
              </h4>
            </div>
            <hr className="border-gray-100" data-id="element-355" />
            <div data-id="element-356">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-357">
                Body — text-base text-gray-600
              </span>
              <p className="text-base text-gray-600" data-id="element-358">
                Centraliza todas las fotos de obra automáticamente desde
                WhatsApp. Sin apps nuevas, sin fricción.
              </p>
            </div>
            <div data-id="element-359">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-360">
                Small — text-sm text-gray-500
              </span>
              <p className="text-sm text-gray-500" data-id="element-361">
                Menos del 0,1% del presupuesto total de una obra promedio.
              </p>
            </div>
            <div data-id="element-362">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-363">
                Caption — text-xs text-gray-400
              </span>
              <p className="text-xs text-gray-400" data-id="element-364">
                © 2026 Obra Digital. Todos los derechos reservados.
              </p>
            </div>
          </div>

          {/* Font weights */}
          <div className="mt-6 bg-white rounded-2xl border border-gray-200 p-8" data-id="element-365">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-366">
              Pesos de fuente
            </p>
            <div className="space-y-4" data-id="element-367">
              <div className="flex items-baseline gap-4" data-id="element-368">
                <span className="w-24 text-xs text-gray-400" data-id="element-369">400 Regular</span>
                <span className="font-normal text-gray-900" data-id="element-370">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-371">
                <span className="w-24 text-xs text-gray-400" data-id="element-372">500 Medium</span>
                <span className="font-medium text-gray-900" data-id="element-373">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-374">
                <span className="w-24 text-xs text-gray-400" data-id="element-375">600 Semibold</span>
                <span className="font-semibold text-gray-900" data-id="element-376">
                  Obra Digital
                </span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-377">
                <span className="w-24 text-xs text-gray-400" data-id="element-378">700 Bold</span>
                <span className="font-bold text-gray-900" data-id="element-379">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-380">
                <span className="w-24 text-xs text-gray-400" data-id="element-381">
                  800 Extrabold
                </span>
                <span className="font-extrabold text-gray-900" data-id="element-382">
                  Obra Digital
                </span>
              </div>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-383" />

        {/* Buttons */}
        <section data-id="element-384">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-385">Botones</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-386">
            Estilos de botones utilizados en la marca.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-8" data-id="element-387">
            {/* Primary */}
            <div data-id="element-388">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-389">
                Primario
              </p>
              <div className="flex items-center gap-4" data-id="element-390">
                <button className="px-4 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-391">
                  Pequeño
                </button>
                <button className="px-5 py-2.5 text-base font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-392">
                  Mediano
                </button>
                <button className="px-6 py-3 text-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-393">
                  Grande
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-394">
                bg-blue-600 text-white rounded-xl
              </p>
            </div>

            {/* Secondary */}
            <div data-id="element-395">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-396">
                Secundario
              </p>
              <div className="flex items-center gap-4" data-id="element-397">
                <button className="px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-398">
                  Pequeño
                </button>
                <button className="px-5 py-2.5 text-base font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-399">
                  Mediano
                </button>
                <button className="px-6 py-3 text-lg font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-400">
                  Grande
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-401">
                border border-gray-300 text-gray-700 bg-white rounded-xl
              </p>
            </div>

            {/* Ghost */}
            <div data-id="element-402">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-403">
                Ghost / Texto
              </p>
              <div className="flex items-center gap-4" data-id="element-404">
                <button className="text-sm font-semibold text-blue-600 hover:text-blue-700 transition-colors" data-id="element-405">
                  Enlace de texto
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-406">
                text-blue-600 hover:text-blue-700
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-407" />

        {/* Text Colors */}
        <section data-id="element-408">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-409">
            Grises de texto
          </h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-410">
            Colores de texto para diferentes jerarquías.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-6" data-id="element-411">
            <div data-id="element-412">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-413">
                text-gray-900
              </span>
              <p className="text-gray-900" data-id="element-414">
                Texto principal, títulos y encabezados importantes.
              </p>
            </div>
            <div data-id="element-415">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-416">
                text-gray-700
              </span>
              <p className="text-gray-700" data-id="element-417">
                Texto secundario con buena legibilidad.
              </p>
            </div>
            <div data-id="element-418">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-419">
                text-gray-600
              </span>
              <p className="text-gray-600" data-id="element-420">
                Texto de cuerpo estándar para párrafos.
              </p>
            </div>
            <div data-id="element-421">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-422">
                text-gray-500
              </span>
              <p className="text-gray-500" data-id="element-423">
                Texto de apoyo y descripciones secundarias.
              </p>
            </div>
            <div data-id="element-424">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-425">
                text-gray-400
              </span>
              <p className="text-gray-400" data-id="element-426">
                Texto sutil, captions y metadatos.
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-427" />

        {/* Spacing & Radius */}
        <section data-id="element-428">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-429">
            Espaciado y Bordes
          </h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-430">
            Valores de espaciado y radio de borde comunes.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-431">
            {/* Border radius */}
            <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-432">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-433">
                Border Radius
              </p>
              <div className="flex items-end gap-4" data-id="element-434">
                <div className="text-center" data-id="element-435">
                  <div className="w-12 h-12 bg-blue-100 rounded-md" data-id="element-436" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-437">
                    rounded-md
                  </span>
                </div>
                <div className="text-center" data-id="element-438">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg" data-id="element-439" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-440">
                    rounded-lg
                  </span>
                </div>
                <div className="text-center" data-id="element-441">
                  <div className="w-12 h-12 bg-blue-100 rounded-xl" data-id="element-442" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-443">
                    rounded-xl
                  </span>
                </div>
                <div className="text-center" data-id="element-444">
                  <div className="w-12 h-12 bg-blue-100 rounded-2xl" data-id="element-445" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-446">
                    rounded-2xl
                  </span>
                </div>
                <div className="text-center" data-id="element-447">
                  <div className="w-12 h-12 bg-blue-100 rounded-full" data-id="element-448" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-449">
                    rounded-full
                  </span>
                </div>
              </div>
            </div>

            {/* Spacing */}
            <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-450">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-451">
                Padding
              </p>
              <div className="space-y-3" data-id="element-452">
                <div className="flex items-center gap-3" data-id="element-453">
                  <div className="bg-blue-600 p-2 rounded" data-id="element-454">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-455" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-456">p-2 (8px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-457">
                  <div className="bg-blue-600 p-4 rounded" data-id="element-458">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-459" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-460">p-4 (16px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-461">
                  <div className="bg-blue-600 p-6 rounded" data-id="element-462">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-463" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-464">p-6 (24px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-465">
                  <div className="bg-blue-600 p-8 rounded" data-id="element-466">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-467" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-468">p-8 (32px)</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <div className="text-center pt-8 pb-4" data-id="element-469">
          <p className="text-xs text-gray-400" data-id="element-470">
            Obra Digital Brand Book — Uso interno
          </p>
        </div>
      </main>
    </div>;
}